import { NgModule } from "@angular/core";
import { RaskCommonModule } from "~app/common/rask-common.module";
import { JlpPeriodService } from "./common/services/jlp-period.service";
import { JusteraLeveransplanFilterService } from "./common/services/justera-leveransplan-filter.service";
import { JusteraLeveransplanService } from "./common/services/justera-leveransplan.service";
import { KundorderradCellComponent } from "./common/services/kundorderrad-cell/kundorderrad-cell.component";
import { JlpSavedSearchesComponent } from "./components/jlp-saved-searches/jlp-saved-searches.component";
import { JusteraLeveransplanComponent } from "./justera-leveransplan.component";
import { JlpKundorderResultComponent } from "./tabs/jlp-kundorder/jlp-kundorder-result/jlp-kundorder-result.component";
import { JlpKundorderComponent } from "./tabs/jlp-kundorder/jlp-kundorder.component";
import { JlpLeverantorsorderResultComponent } from "./tabs/jlp-leverantorsorder/jlp-leverantorsorder-result/jlp-leverantorsorder-result.component";
import { JlpLeverantorsorderComponent } from "./tabs/jlp-leverantorsorder/jlp-leverantorsorder.component";
import { JlpProduktionsomradenResultComponent } from "./tabs/jlp-produktionsomraden/jlp-produktionsomraden-result/jlp-produktionsomraden-result.component";
import { JlpProduktionsomradenComponent } from "./tabs/jlp-produktionsomraden/jlp-produktionsomraden.component";

@NgModule({
    imports: [
        RaskCommonModule,
        JusteraLeveransplanComponent,
        JlpLeverantorsorderComponent,
        JlpProduktionsomradenComponent,
        JlpKundorderComponent,
        JlpKundorderResultComponent,
        JlpLeverantorsorderResultComponent,
        JlpProduktionsomradenResultComponent,
        JlpSavedSearchesComponent,
        KundorderradCellComponent
    ],
    providers: [
        JusteraLeveransplanService,
        JusteraLeveransplanFilterService,
        JlpPeriodService
    ]
})
export class JusteraLeveransplanModule { }
